import script from "./PromotedProductContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./PromotedProductContainer.vue?vue&type=script&lang=ts&setup=true"

import "./PromotedProductContainer.vue?vue&type=style&index=0&id=a888d800&lang=css"

const __exports__ = script;

export default __exports__